export const FORM_EVENT = {
    GRID_VALUE_CHANGED: 'GRID_VALUE_CHANGED'
}
